export default "__VITE_ASSET__MNUMewNX__"